module.exports = {
  data: {
    navs: [
      {
        normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/index.png',
        activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/index-active.png',
        link: {
          type: 'deeplink',
          value: 'beastapp://index'
        },
        title: '首页'
      },
      {
        normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/category.png',
        activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/category-active.png',
        link: {
          type: 'deeplink',
          value: 'beastapp://entry?name=category-v2'
        },
        title: '选购'
      },
      {
        normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/discovery.png',
        activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/discovery-active.png',
        link: {
          type: 'deeplink',
          value: 'beastapp://entry?name=funny'
          // value: 'beastapp://entry?name=discovery'
        },
        title: '有趣'
      },
      {
        normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/store.png',
        activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/store-active.png',
        link: {
          type: 'deeplink',
          value: 'beastapp://entry?name=store'
        },
        title: '门店'
      },
      {
        normalIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/my.png',
        activeIcon: 'http://img.thebeastshop.com/app/index/bottombar4.1/my-active.png',
        link: {
          type: 'deeplink',
          value: 'beastapp://entry?name=member'
        },
        title: '我的'
      },
    ]
  }
}



// WEBPACK FOOTER //
// ./static/components/navbar-bottom/test/data.js